/* eslint-disable react/jsx-props-no-spreading */
import type { HTMLAttributes, ReactNode } from 'react';

interface TabPanelProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  activeTabId: number;
  tabId: number;
}

const TabPanel = ({ children, tabId, activeTabId }: TabPanelProps) => {
  const isActiveTab = tabId === activeTabId;
  return (
    <div
      className={`flex-col flex-grow flex-shrink basis-0 min-w-0 overflow-auto ${
        isActiveTab ? 'flex' : 'hidden'
      }`}
      role="tabpanel"
      aria-hidden={!isActiveTab}
    >
      {children}
    </div>
  );
};

export default TabPanel;
